<span *ngIf="room.bell!=null&& room.bell!=0"><img style="width: 24px;"
                                                  [src]="'assets/img/1000Bell.png'">{{room.bell}}</span>
<span *ngIf="room.ticket!=null && room.ticket!=0"><img style="width: 24px;"
                                                       [src]="'assets/img/PlaneTicket.png'">{{room.ticket}}</span>
<span *ngIf="room.entry_condition!=null&&room.entry_condition.length>0"><br>{{room.entry_condition}}</span>
